module.exports = __webpack_public_path__ + "static/media/hero2.73316fb7.jpg";